import { JSONPath } from "jsonpath-plus";
import { RadioGroup } from "../RadioGroup";
import { ToggledContainer } from "../ToggledContainer";
import { AttributeGroup, ProductAttribute } from "./types";
import fr from './translations/fr.json'
import en from './translations/en.json'

function t(key: string, currentLanguage = "fr") {
    return JSONPath({ path: key, json: currentLanguage === 'fr' ? fr : currentLanguage === 'en' ? en : fr });
}


export interface OptionRendererWithPriceProps {
    option: { id: string | number | null, label: string, value: string | number, data?: Record<string, any> },
    onChange: (id: string | number | null) => void
    selectedOptionId: string | null | number;
    name: string | undefined
    currentLanguage: string
    creditSystemEnabled: boolean
}
export function OptionRendererWithPrice({
    option,
    onChange,
    selectedOptionId,
    name,
    currentLanguage,
    creditSystemEnabled = false
}: OptionRendererWithPriceProps) {
    return <div className="d-flex align-items-center justify-content-between w-100">
        <div className="form-check">
            <input className="cursor-pointer form-check-input" onChange={(event) => onChange(option.id)} checked={selectedOptionId === option.id} type="radio" name={name} id={name} />
            <label className="form-check-label fs-5">{option.label}</label>
        </div>
        {creditSystemEnabled && option.data?.increasePriceValue ? <span className="py-2 px-4 bg-pink rounded-pill text-white fs-8"> {option.data?.increasePriceValue} {t("credits", currentLanguage)}</span> : false}
        {creditSystemEnabled && !option.data?.increasePriceValue ? <span className="py-2 px-4 text-dark rounded-pill text-white fs-8">{t("default", currentLanguage)}</span> : false}
    </div>
}


export interface ProductAttributeGroupManagerProps {
    currentLanguage: string;
    groups: AttributeGroup<ProductAttribute>[]
    selectedOptions: { id: number, groupId: number }[]
    setSelectedOptions: (params: { id: number, groupId: number }[]) => void
    creditSystemEnabled: boolean
}

export function ProductAttributeGroupManager({
    groups = [],
    selectedOptions = [],
    setSelectedOptions = (params: { id: string | number | null, groupId: number }[]) => { return; },
    currentLanguage,
    creditSystemEnabled = false
}: ProductAttributeGroupManagerProps) {
    return <div className="mb-10">
        <ToggledContainer label="Paramètres avancés">

            {groups.map((group, index) => <RadioGroup
                key={`product-attribute-group-${group.id}`}
                selectedOptionId={
                    selectedOptions.find((selectedOption) => selectedOption.groupId === group.id)?.id || null
                }
                onChange={(id) => {
                    const optionsWithoutCurrentGroupOption = selectedOptions.filter((option) => option.groupId !== group.id)
                    const updatedSelectedOptions = [
                        ...optionsWithoutCurrentGroupOption,
                        {
                            groupId: group.id as number,
                            id: id as number
                        }
                    ]
                    setSelectedOptions(updatedSelectedOptions)
                }}
                options={group.attributes.map((attribute: ProductAttribute) => ({
                    label: `${attribute.value} ${t(attribute.displayLabel || "", currentLanguage)}`,
                    id: attribute.id || null,
                    value: attribute.value,
                    data: {
                        increasePriceValue: attribute.increasePriceValue
                    }
                }))}
                name={`${group.id as unknown as number}`}
                optionRenderer={(props) => OptionRendererWithPrice({
                    ...props,
                    currentLanguage,
                    creditSystemEnabled
                })}
            />)}

        </ToggledContainer>

    </div>
}